<template>
  <el-dialog
      :visible.sync="show"
      width="838px"
      :close-on-click-modal="false"
      @close="close"
  >
    <div class="legal-notice-container">
      <div class="title">
        <span>法律声明</span>
        <div class="line"></div>
      </div>
      <div class="content">
        <div class="c-desc" v-html="content"></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "LegalNoticeLayer",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      content: ''
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.show = val
          this.$request.get('/Website/legalNotice')
              .then(res => {
                if (res.code === 0) {
                  this.content = res.data.content
                }
              })
        }
      }
    }
  },
  methods: {
    /**
     * 关闭
     */
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.legal-notice-container {
  padding: 0 80px 30px 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    color: #2D2D2D;
    font-size: 38px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      width: 82px;
      height: 12px;
      border-radius: 11px;
      background-color: #1464FF;
    }
  }

  .content {
    margin-top: 20px;

    ::v-deep {
      .c-desc img {
        width: 100%;
      }
    }
  }
}
</style>